// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"fce325ef","358":"37157cf3","378":"4b04cf44","621":"68104265","688":"2a64f6ab","719":"bedc8be5","988":"8123b9d5"}[chunkId] + ".chunk.css";
};